import React from 'react';
import {
  FDBodyText,
  FDEmphasisSurface, FDHeadlineText, FDIcon, FDPaper, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('QuestionsPicklist', (theme) => ({
  item: {
    cursor: 'pointer',
    minWidth: 200,
    maxWidth: 400,
    flex: 1,
  },
  icon: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    '& > .FD-MuiSvgIcon-root': {
      fill: theme.palette.success.light,
    },
  },
}));

export const QuestionsPicklist = ({
  value, options, onChange,
}) => {
  const handleChange = (id) => {
    if (value.includes(id)) {
      return value.filter(v => v !== id);
    }

    return [...value, id];
  };

  const classes = useStyles();

  return (
    <FDStack justifyContent={'flex-start'} spacing={4} wrap>
      {options.map((option, i) => {
        const isSelected = value.includes(option.id);
        const Component = isSelected ? FDEmphasisSurface : FDPaper;
        const paperProps = isSelected ? { appearance: 'elevated' } : { appearance: 'outlined' };

        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <div
            className={classes.item}
            onClick={() => {
              onChange(handleChange(option.id));
            }}
            {...DataValueMap.init('questions-picklist-item')
              .append(DataValueMap.keyMap.dataIndex, i.toString())
              .build()}
          >
            <Component {...paperProps} padding={4} height={'100%'}>
              {isSelected ? (
                <div className={classes.icon}>
                  <FDIcon icon={'check'} />
                </div>
              ) : null}
              <FDStack direction={'column'} spacing={2}>
                <FDHeadlineText size={'sm'} value={option.prompt} color={isSelected ? 'textAttention' : undefined} />
                <FDBodyText value={option.description} />
              </FDStack>
            </Component>
          </div>
        );
      })}
    </FDStack>
  );
};

QuestionsPicklist.propTypes = {
  value: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
